var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thirdWrap"},[_c('GoBack',{attrs:{"title":_vm.title,"nextPath":_vm.$route.query.nextPath,"nextQuery":_vm.title === '捐赠详情'
        ? JSON.stringify({
            title: '我的捐赠',
            status: _vm.$route.query.status,
            curSelectTab: Number(_vm.$route.query.donateType) === 1 ? '捐衣' : '捐物',
          })
        : ''}}),(_vm.title === '捐赠详情')?_c('MyDonateDetail'):_c('ProjectDetail',{attrs:{"name":_vm.$route.query.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }